import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge } from '@wit-support/ui';
import { adsBatchStateLabelRu, adsLaunchStatusLabelRu, adsMediaStateLabelRu, } from './status-labels.js';
export const ADS_LAUNCH_STATUS_TONE = {
    draft: 'neutral',
    scheduled: 'info',
    creating: 'info',
    ready_paused: 'warning',
    blocked: 'danger',
    activating: 'info',
    waiting_start: 'success',
    running: 'success',
    /** Пачку отменили до создания — итог, не тревога. */
    cancelled: 'neutral',
    /** Пауза человеком или при отмене пачки — обычное состояние, не тревога. */
    paused: 'neutral',
    paused_on_drift: 'danger',
    pause_failed: 'danger',
    needs_attention: 'danger',
    failed: 'danger',
    rolling_back: 'warning',
    rolled_back: 'neutral',
};
export const ADS_BATCH_STATE_TONE = {
    draft: 'neutral',
    running: 'info',
    needs_attention: 'danger',
    failed: 'danger',
    active: 'success',
    done_manual: 'warning',
    cancelled: 'neutral',
    /** Всё созданное откачено — итог, не тревога. */
    rolled_back: 'neutral',
};
export const ADS_MEDIA_STATE_TONE = {
    queued: 'neutral',
    uploading: 'info',
    processing: 'info',
    ready: 'success',
    failed: 'danger',
    archived: 'neutral',
};
const toneOf = (map, v) => Object.hasOwn(map, v) ? map[v] : 'neutral';
/**
 * Статус запуска. `reason` — `activation.reason` auto-ads: уточняет
 * «Требует внимания» («Подмена после включения», «Не удалось проверить — …»).
 */
export function AdsLaunchStatusBadge({ status, reason, }) {
    return (_jsx(Badge, { variant: toneOf(ADS_LAUNCH_STATUS_TONE, status), "data-status": status, children: adsLaunchStatusLabelRu(status, reason) }));
}
/** Состояние пачки запусков. */
export function AdsBatchStateBadge({ state }) {
    return (_jsx(Badge, { variant: toneOf(ADS_BATCH_STATE_TONE, state), "data-state": state, children: adsBatchStateLabelRu(state) }));
}
/**
 * Состояние файла медиатеки в кабинете. `prefix` — чей это файл
 * («Кабинет 1: Готов»); `title` — текст ошибки Meta во всплывашке.
 */
export function AdsMediaStateBadge({ state, prefix, title, }) {
    return (_jsxs(Badge, { variant: toneOf(ADS_MEDIA_STATE_TONE, state), title: title ?? undefined, "data-state": state, children: [prefix !== undefined ? `${prefix}: ` : '', adsMediaStateLabelRu(state)] }));
}
//# sourceMappingURL=ads-badges.js.map